import type { ParticipantId } from "../types/common";
import type { ArchetypeConfig, InitialEntitySeed } from "../types/game-config";

export const DEFAULT_INITIAL_ENTITY_SEED: ReadonlyArray<InitialEntitySeed> = [
  { id: "a-heavy-1", archetype: "HEAVY", ownerIndex: 0, x: 2, y: 2 },
  { id: "a-medium-1", archetype: "MEDIUM", ownerIndex: 0, x: 4, y: 2 },
  { id: "a-light-1", archetype: "LIGHT", ownerIndex: 0, x: 6, y: 2 },
  { id: "b-heavy-1", archetype: "HEAVY", ownerIndex: 1, x: 2, y: 7 },
  { id: "b-medium-1", archetype: "MEDIUM", ownerIndex: 1, x: 4, y: 7 },
  { id: "b-light-1", archetype: "LIGHT", ownerIndex: 1, x: 6, y: 7 },
];

function getArchetypeConfig(
  archetype: string,
  configs: ReadonlyArray<ArchetypeConfig>,
): ArchetypeConfig {
  const config = configs.find((item) => item.archetype === archetype);
  if (!config) {
    throw new Error(`No config found for archetype: ${archetype}`);
  }
  return config;
}

export function createInitialEntities(
  archetypes: ReadonlyArray<ArchetypeConfig>,
  participantIds: readonly [ParticipantId, ParticipantId] = ["P1", "P2"],
  seedEntities: ReadonlyArray<InitialEntitySeed> = DEFAULT_INITIAL_ENTITY_SEED,
) {
  return seedEntities.map((seed) => {
    const config = getArchetypeConfig(seed.archetype, archetypes);
    return {
      id: seed.id,
      archetype: seed.archetype,
      owner: participantIds[seed.ownerIndex],
      x: seed.x,
      y: seed.y,
      radius: config.radius,
      mass: config.mass,
      eliminated: false,
    };
  });
}
